import { put, take, call } from 'redux-saga/effects';
import { GET_DOMAINS_FOR_ENTITY_REQUEST } from './types';
import {
  getDomainsForEntitySuccess,
  getDomainsForEntityError,
} from './actions';
import withLoading from '../../sagas/loadingSaga';

export default function* domainsSaga(api) {
  while (true) {
    const domainsForEntityAction = yield take(GET_DOMAINS_FOR_ENTITY_REQUEST);
    const { entityId } = domainsForEntityAction.payload;
    yield* withLoading(function* () {
      yield call(getDomainsForEntity, api, entityId);
    });
  }
}

function* getDomainsForEntity(api, entityId) {
  try {
    const domainsData = yield call(api.getDomainsForEntity, entityId);
    yield put(
      getDomainsForEntitySuccess({
        domainsData: domainsData.data,
      }),
    );
  } catch (error) {
    yield put(getDomainsForEntityError(error));
  }
}
